module.exports = __webpack_public_path__ + "img/havefun_title_kr.427bd588.jpg";